interface ArticleContentProps {
  content: string;
}

export default function ArticleContent({ content }: ArticleContentProps) {
  const blocks = content.split("\n\n").filter((b) => b.trim());
  return (
    <div className="space-y-5">
      {blocks.map((block, i) => {
        const lines = block.split("\n");
        const first = lines[0];
        const isHeading = /^\d+\./.test(first.trim());
        if (isHeading && lines.length > 1) {
          return (
            <div key={i}>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mb-2 flex items-start gap-2">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2.5" />
                {first}
              </h3>
              <p className="text-sm md:text-[15px] text-foreground-700 leading-loose">
                {lines.slice(1).join("")}
              </p>
            </div>
          );
        }
        if (isHeading) {
          return (
            <h3 key={i} className="font-heading font-bold text-base md:text-lg text-foreground-950">
              {first}
            </h3>
          );
        }
        return (
          <p key={i} className="text-sm md:text-[15px] text-foreground-700 leading-loose">
            {block}
          </p>
        );
      })}
    </div>
  );
}